import DeviceManager, { OnPromiseAttrType } from '../utils/device-manager';

type FooterType = {
    mobileInitialized: boolean,
    $togglers: NodeListOf<HTMLElement>|null,
    init(): void,
    onClickCallback(evt: MouseEvent): void,
    calcFooterSubmenuHeight(attr: OnPromiseAttrType, $toggler: HTMLElement): void,
    enableMobile(): void,
    disableMobile(): void,
};

const Footer: FooterType = {
    mobileInitialized: false,
    $togglers: null,

    init() {
        const that = this;
        this.mobileInitialized = false;
        this.$togglers = document.querySelectorAll<HTMLElement>('.js-footer-menu-toggler');

        DeviceManager.addCallback(attr => {
            if (!that.mobileInitialized && !DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                that.enableMobile();
            } else if (that.mobileInitialized && DeviceManager.isGreaterThanOrEqual(attr.current, 'md')) {
                that.disableMobile();
            }
        });
    },

    /**
     * Click on submenu toggler
     * 
     * @param {MouseEvent} evt
     * 
     * @return {void}
     */
    onClickCallback(evt: MouseEvent) : void {
        const $toggler = evt.target as HTMLElement;
        $toggler.classList.toggle('closed');
    },

    /**
     * Calculate submenu height
     * 
     * @param {OnPromiseAttrType} attr 
     * @param {HTMLElement} $toggler 
     * 
     * @return {void}
     */
    calcFooterSubmenuHeight(attr: OnPromiseAttrType, $toggler: HTMLElement) : void {
        const $submenu = $toggler.nextElementSibling as HTMLElement|null;
        const isClosed = $toggler.classList.contains('closed');

        if (!$submenu) {
            return;
        }

        $submenu.classList.add('no-transition');

        $toggler.classList.remove('closed');

        $submenu.style.maxHeight = '';
        $submenu.style.maxHeight = $submenu.clientHeight + 'px';

        if (isClosed) {
            $toggler.classList.add('closed');
        }

        $submenu.classList.remove('no-transition');
    },

    enableMobile() : void {
        this.mobileInitialized = true;

        this.$togglers?.forEach(($toggler, index) => {
            $toggler.addEventListener('click', this.onClickCallback);
            DeviceManager.addWindowCallback('calcFooterSubmenuHeight-' + index, this.calcFooterSubmenuHeight, $toggler);
        });
    },

    disableMobile() : void {
        this.mobileInitialized = false;

        this.$togglers?.forEach(($toggler, index) => {
            $toggler.removeEventListener('click', this.onClickCallback);
            DeviceManager.removeWindowCallback('calcFooterSubmenuHeight-' + index);

            $toggler.classList.add('closed');
            ($toggler.nextElementSibling as HTMLElement).style.maxHeight = '';
        });
    },
};

export default Footer;
